import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    title: "Learning How To Fly",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kjbr8280-0/book/z/r/9/learning-how-to-fly-original-imafyx6zuhvfhv94.jpeg?q=70",
    description: `Dr A.P.J. Abdul Kalam had a great belief in the power of the youth. He met over 21 million children and young people in India and outside and spoke to them about the power of knowledge, ambition, moral behaviour and the need to bring about change in society.`,
    author: "A.P.J abdual kalam",
    sellPrice: "129",
    costPrice: "197",
    discount: "33",
    ratings: "4.5",
    categoryName: "Fiction",
  },
  {
    _id: uuid(),
    title: "You are the Best Wife",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/jyeq64w0/book/5/4/0/you-are-the-best-wife-original-imafgkyugczdayt8.jpeg?q=70",
    description: `Ajay believes in living for himself; Bhavna teaches him to live for others. Ajay is a planner for life; Bhavna makes him live in every moment. You are the Best Wife is a story of two people with contradictory ideologies who fall in love. It changes them for good. `,
    author: "Ajay K Pandey",
    sellPrice: "125",
    costPrice: "175",
    discount: "28",
    ratings: "3.5",
    categoryName: "Family_relationship",
  },
  {
    _id: uuid(),
    title: "How to Win Friends and Influence People",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/krxtrww0/book/g/8/1/how-to-win-friends-and-influence-people-original-imag5m73dmc8bzhd.jpeg?q=70",
    description: `How to Win Friends & Influence People is a classic self-help book by Dale Carnegie. Summary of the Book Dale Carnegie discusses how to increase improve one’s popularity by winning them over through simple changes in one’s actions. He teaches readers how to impress people with his world-famous techniques which can help readers learn how to sell ideas and products by controlling their audience’s emotions effectively. `,
    author: "Carnegie Dale",
    costPrice: "90",
    sellPrice: "150",
    discount: "40",
    ratings: "2.8",
    categoryName: "Family_relationship",
  },
  {
    _id: uuid(),
    title: "One Indian Girl",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/ki96c280-0/book/3/p/n/one-indian-girl-original-imafy2zrymfbtygz.jpeg?q=70",
    description: `One Indian Girl is about a girl named Radhika Mehta who is an investment banker at Goldman Sachs. Once a nerd by nature, she is now all set to get hitched to Brijesh Gulati and arrives for her destination wedding in Goa. However, as the D-Day looms closer, she discovers that marrying Gulati is not as easy as it seems. Soon, one by one, things start to get messy and threaten to fall apart? Can Radhika get herself out of this mess or will it be the end of the road for her? Read One Indian Girl and find out.`,
    author: "Chetan Bhagat",
    costPrice: "157",
    sellPrice: "195",
    discount: "19",
    ratings: "1.9",
    categoryName: "Family_relationship",
  },
  {
    _id: uuid(),
    title: "Wake Up, Life is Calling",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/jt7jhjk0/book/6/0/7/wake-up-life-is-calling-original-imafehzjxbac5hsz.jpeg?q=70",
    description: `“Wake Up, Life is Calling” is a sequel to the national bestseller, “Life is What You Make it” by the popular Indian writer, Preeti Shenoy. Ankita, the protagonist of this story, overcomes her troublesome past and starts leading a normal life. She even joins a college to pursue creative writing. With everything falling into place, Ankita doesn’t realize that trouble is slowly creeping back into her life. Will Ankita be able to beat the odds this time?`,
    author: "Shenoy Preeti",
    costPrice: "99",
    sellPrice: "199",
    discount: "50",
    ratings: "3.1",
    categoryName: "Self_help",
  },
  // break
  {
    _id: uuid(),
    title: "The Power of Your Subconscious Mind",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/ktn9pjk0/book/m/q/n/the-power-of-your-subconscious-mind-original-imag6xbtcrb2mmrh.jpeg?q=70",
    description: `This book by Dr. Joseph Murphy teaches you to unlock the powers of your subconscious mind. He combines spiritual wisdom with scientific research, and explains how the subconscious mind influences every single thing that you do. From getting rid of bad habits to getting that promotion you want, this book will change your life and open up doors to happiness, success, prosperity and peace.`,
    author: "Murphy Joseph",
    costPrice: "127",
    sellPrice: "275",
    discount: "53",
    ratings: "2.9",
    categoryName: "Philosophy",
  },
  {
    _id: uuid(),
    title: "The Psychology of Money",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kjom6q80-0/regionalbooks/o/i/t/the-psychology-of-money-original-imafvb5vbgcczykj.jpeg?q=70",
    description: `Doing well with money isn’t necessarily about what you know. It’s about how you behave. And behavior is hard to teach, even to really smart people.Money—investing, personal finance, and business decisions—is typically taught as a math-based field, where data and formulas tell us exactly what to do.`,
    author: "Housel Morgan",
    costPrice: "216",
    sellPrice: "399",
    discount: "45",
    ratings: "4.6",
    categoryName: "Self_help",
  },
  {
    _id: uuid(),
    title: "Everything I Never Told You",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kgzg8sw0/book/8/5/3/everything-i-never-told-you-original-imafx3s2fzftvehp.jpeg?q=70",
    description: `We can live without religion, but we cannot survive without love. Roshan and Soha were not just class-mates and neighbours, but also best friends. They wanted to be together, but the world saw them as a Hindu and a Muslim before everything else. Roshan failed to convince his father and had to let Soha go. He married Manisha with the hope of moving on, and his life unfolded with a new definition of love.`,
    author: "Pandey Ajay K.",
    costPrice: "110",
    sellPrice: "199",
    discount: "44",
    ratings: "4",
    categoryName: "Fiction",
  },
  {
    _id: uuid(),
    title: "The Dhoni Touch",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kwmfqfk0/book/o/w/l/the-dhoni-touch-original-imag99z3qv8y5z4n.jpeg?q=70",
    description: `Be it his signature helicopter shot or his ever-calm demeanour, Mahendra Singh Dhoni has always found a way to tap into the hearts of his fans. For someone who was training to be a footballer, who could have told that Mahi was going to take the world of cricket by storm. In The Dhoni Touch: Unravelling the Enigma That Is Mahendra Singh Dhoni, Bharat Sundaresan reaches out to some of Mahi’s closest friends to find out how he became the man that he is today. `,
    author: "Sundaresan Bharat",
    costPrice: "171",
    sellPrice: "299",
    discount: "42",
    ratings: "3.2",
    categoryName: "Non_fiction",
  },
  {
    _id: uuid(),
    title: "Skill It, Kill It",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kpedle80/book/i/6/o/skill-it-kill-it-original-imag3n7ma5nrqvvw.jpeg?q=70",
    description: `Ever wondered why CEOs, leaders and recruiters talk endlessly about soft skills? Job interviews, promotions, appraisals, teamwork, managing workplace challenges, communication skills and a lot more-soft skills give you a sizeable professional edge to ace all of these. In this book, Ronnie Screwvala shares personal stories and observations from his many failures and few successes to give you an insider's view of the 'invisible' skills, which can cut years off your learning curve. Practical, actionable and peppered with advice from successful leaders, Skill It, Kill It will ensure you're future-proof in these ever-changing times and ready to stand out among your peers. If you are ready to RISE COMMIT LISTEN SACRIFICE and really want it BADLY Then your time is NOW Welcome to #LifeLongLearning An essential career guide on exceling in the corporate world!`,
    author: "Screwvala Ronnie",
    costPrice: "207",
    sellPrice: "299",
    discount: "30",
    ratings: "2.6",
    categoryName: "Self_help",
  },
  {
    _id: uuid(),
    title: "Start With Why",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kufuikw0/book/b/a/w/start-with-why-original-imag7jt996bhfxuz.jpeg?q=70",
    description: `The reason why only a few people are able to be more successful than the rest and bring out their best creative instincts, the reason why only a small number of businessmen are able to make remarkable profits over and over again, and the reason why a few companies endure the test of time is nothing but the fact that they dwell on probing and continuously ask why, rather than how or what.`,
    author: "Sinek Simon",
    costPrice: "325",
    sellPrice: "599",
    discount: "45",
    ratings: "2.1",
    categoryName: "Philosophy",
  },
  {
    _id: uuid(),
    title: "The Magic Mindset: How to Find Your Happy Place ",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/ktd9mkw0/book/4/d/h/the-magic-mindset-original-imag6pzyzh5tkafe.jpeg?q=70",
    description: `Can you find yourself after you have lost that special someone? A disillusioned and heartbroken Anusha finds herself in the small world of WeDonate.com. Struggling to cope with her feelings and the job of raising money for charity, she reluctantly searches for a worthwhile cause to support. For Ananth, who has been on the opposite side, no life is less worthy, no cause too small to support.`,
    author: "Shenoy Preeti",
    costPrice: "140",
    sellPrice: "250",
    discount: "44",
    ratings: "3",
    categoryName: "Non_fiction",
  },
  {
    _id: uuid(),
    title: "Wish I Could Tell You",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kwcfngw0/book/3/8/x/wish-i-could-tell-you-original-imag9ffkhqehzwzs.jpeg?q=70",
    description: `Ever wondered why CEOs, leaders and recruiters talk endlessly about soft skills? Job interviews, promotions, appraisals, teamwork, managing workplace challenges, communication skills and a lot more-soft skills give you a sizeable professional edge to ace all of these. In this book, Ronnie Screwvala shares personal stories and observations from his many failures and few successes to give you an insider's view of the 'invisible' skills, which can cut years off your learning curve. Practical, actionable and peppered with advice from successful leaders, Skill It, Kill It will ensure you're future-proof in these ever-changing times and ready to stand out among your peers. If you are ready to RISE COMMIT LISTEN SACRIFICE and really want it BADLY Then your time is NOW Welcome to #LifeLongLearning An essential career guide on exceling in the corporate world!`,
    author: "Screwvala Ronnie",
    costPrice: "207",
    sellPrice: "299",
    discount: "30",
    ratings: "1.7",
    categoryName: "Self_help",
  },
  {
    _id: uuid(),
    title: "Who Will Cry When You Die?",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kplisnk0/book/1/o/h/who-will-cry-when-you-die-original-imag3shejezfsfgr.jpeg?q=70",
    description: `Who Will Cry When You Die? Is a book that has transformed the lives of thousands. It will be the guiding light that leads you to a path that takes you on a journey of discovering a new way to live. This easy-to-read yet wisdom-rich manual is Robin S. Sharma’s offering that gives you 101 simple solutions to life’s most complex problems. It covers every aspect ranging from a little-known method for beating stress and worry to a powerful way to enjoy the journey while you create a legacy that lasts.`,
    author: "Sharma Robin S.",
    costPrice: "140",
    sellPrice: "199",
    discount: "29",
    ratings: "3.9",
    categoryName: "Self_help",
  },
  {
    _id: uuid(),
    title: "ON THE TRAIL OF THE BLACK - Tracking Corruption",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/k6qsn0w0/book/2/2/0/on-the-trail-of-the-black-original-imafp54cpuzzzsmz.jpeg?q=70",
    description: `Bibek Debroy is an eminent economist and is presently the Chairman of the Economic Advisory Council to the Prime Minister and Member of NITI Aayog, Government of India. He has authored and edited several books, papers and popular articles and has also been a consulting/contributing editor with several newspapers. K ishore Arun Desai is an Officer on Special Duty at NITI Aayog with Bibek Debroy. He has, along with Debroy, co-authored analytical policy papers on subjects such as simultaneous elections and changing India?s financial year.`,
    author: "Kishow Arun Desai",
    costPrice: "444",
    sellPrice: "595",
    discount: "25",
    ratings: "4.2",
    categoryName: "Philosophy",
  },
  {
    _id: uuid(),
    title: "Shoe Dog",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kr2e3680/book/y/j/x/shoe-dog-original-imag4xrabhhsznxd.jpeg?q=70",
    description: `'A refreshingly honest reminder of what the path to business success really looks like ... It's an amazing tale' Bill Gates 'The best book I read last year was Shoe Dog, by Nike's Phil Knight. Phil is a very wise, intelligent and competitive fellow who is also a gifted storyteller' Warren Buffett In 1962, fresh out of business school, Phil Knight borrowed $50 from his father and created a company with a simple mission: import high-quality, low-cost athletic shoes from Japan. Selling the shoes from the boot of his Plymouth, Knight grossed $8000 in his first year. `,
    author: "Knight Phil",
    costPrice: "289",
    sellPrice: "499",
    discount: "42",
    ratings: "4.9",
    categoryName: "Non_fiction",
  },
  {
    _id: uuid(),
    title: "Because Life is a Gift",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kj1r53k0-0/book/r/t/a/because-life-is-a-gift-stories-of-hope-courage-and-perseverance-original-imafyphg87qhfcnn.jpeg?q=70",
    description: `We come across people who could tell you a story of courage everyday. They have braved the worst times and made a place for themselves in the world. This book brings to you a collection of stories that speak of hope, courage and perseverance. A little boy is confined to a wheelchair, but that doesn’t stop him from becoming India’s youngest patent holder in chess.`,
    author: "Chabbra MS Disha",
    costPrice: "95",
    sellPrice: "175",
    discount: "45",
    ratings: "3.3",
    categoryName: "Fiction",
  },
  {
    _id: uuid(),
    title: "Her Last Wish",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/jplif0w0/book/8/7/8/her-last-wish-original-imafbt2huwgfzzj8.jpeg?q=70",
    description:
      "Her Last Wish is an inspiring tale of love and heartbreak and it tests a man’s resilience after his girlfriend is diagnosed with a fatal disease. Vijay, who is overburdened with his father’s over expectations, finds love and luck when Aastha enters his life, eventually becoming his sole source of happiness in life. However, fate has other plans for him as she is diagnosed with a life-threatening disease. ",
    author: "Panday Ajay K",
    costPrice: "109",
    sellPrice: "175",
    discount: "37",
    ratings: "2.5",
    categoryName: "Fiction",
  },
  {
    _id: uuid(),
    title: "Believe",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/kwtkxow0/book/f/q/d/believe-original-imag9enntcfngng5.jpeg?q=70",
    description: `Believe, Sachin Tendulkar told him - and he took it to heart, getting the word etched on his arm as a tattoo. In this book, Suresh Raina takes us through the challenges he faced as a young cricketer. He was bullied in school and at cricket camps, but he always punched above his weight, overcoming every adversity life threw at him and never giving up. This is the story of the lessons he learnt and the friendships he built.`,
    author: "Bharat Sundaresan",
    costPrice: "190",
    sellPrice: "299",
    discount: "36",
    ratings: "4.7",
    categoryName: "Non_fiction",
  },
  {
    _id: uuid(),
    title: "The Richest Man In Babylon ",
    imgSrc:
      "https://rukminim2.flixcart.com/image/416/416/ku5ufm80/book/f/c/q/the-richest-man-in-babylon-original-imag7c7myyegb5q2.jpeg?q=70",
    description: `The Richest Man in Babylon is a 1926 book by George S. Clason that dispenses financial advice through a collection of parables set 4,000 years ago in ancient Babylon. The book remains in print almost a century after the parables were originally published, and is regarded as a classic of personal financial advice.`,
    author: "Clason George S.",
    costPrice: "117",
    sellPrice: "150",
    discount: "22",
    ratings: "1.4",
    categoryName: "Non_fiction",
  },
];